import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { LocalizePipe } from '../../../i18n/pipes/lozalize.pipe';

@Component({
    selector: 'app-configurator',
    templateUrl: './configurator.component.html',
    styleUrls: ['./configurator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, TranslatePipe, LocalizePipe],
})
export class ConfiguratorComponent implements OnInit {
    private translateService = inject(TranslateService);

    list!: string[];

    ngOnInit(): void {
        this.list = [
            <string>this.translateService.instant('CONFIGURATOR.content_full_list.0'),
            <string>this.translateService.instant('CONFIGURATOR.content_full_list.1'),
            <string>this.translateService.instant('CONFIGURATOR.content_full_list.2'),
            <string>this.translateService.instant('CONFIGURATOR.content_full_list.3'),
            <string>this.translateService.instant('CONFIGURATOR.content_full_list.4'),
            <string>this.translateService.instant('CONFIGURATOR.content_full_list.5'),
            <string>this.translateService.instant('CONFIGURATOR.content_full_list.6'),
        ];
    }
}
